import { SentryProps, TrackingService, YesErrorTrackingProps } from './types'
import * as Sentry from '@sentry/react'

const SERVICE_MAPPINGS: Record<
  TrackingService,
  ({ ...props }: SentryProps) => void
> = {
  sentry: ({ publicKey, traceTargets }) =>
    Sentry.init({
      dsn: publicKey,
      tracesSampleRate: 1.0,
      tracePropagationTargets: traceTargets,
      integrations: [new Sentry.BrowserTracing()]
    })
}

/**
 * A wrapper for tracking services
 * @function
 * @param {string} service - The service used for tracking.
 * @param {string} publicKey - The key used by the service.
 * @param {Array<string | RegExp>} traceTargets - An array containing application URLs for tracking.
 */
export default function YesErrorTracking({
  service,
  ...props
}: YesErrorTrackingProps) {
  SERVICE_MAPPINGS[service](props)
}
